import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";

import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { planBenefitSearchActions } from "@/App/actions";
import { PlanBenefitTypes } from "@/types";

export function* listPlanBenefit(data: {}): Generator {
  return yield apiService({
    url: "/plan_benefit/list",
    method: "POST",
    data,
  });
}

function formatData(data: Array<PlanBenefitTypes.PlanBenefitResults>): Array<PlanBenefitTypes.PlanBenefit> {
  const formattedData = data.map(({ plan_benefit }) => {
    return plan_benefit;
  });
  return formattedData;
}

export function* searchPlanBenefitWorker(action: ReturnType<typeof planBenefitSearchActions.searchPlanBenefitList>): SagaIterator {
  const { searchPlanBenefitListResults } = planBenefitSearchActions;
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const { results, result_count } = yield call(listPlanBenefit, payload);
    const formatListResult = formatData(results);

    yield put(searchPlanBenefitListResults({ results: formatListResult, result_count }));
    yield put(stopSubmit(formName));
  } catch (error) {
    const { data: { message = "Request failed" } = {} } = error;
    yield put(stopSubmit(formName));
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* searchPlanBenefitWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SEARCH_FOR_PLAN_BENEFIT_LIST, searchPlanBenefitWorker);
}
